module.exports = __webpack_public_path__ + "img/graph.1c7560d2.png";